var keyboardAccessibility = require("base/components/keyboardAccessibility");
var $window = $(window);

/**
* Sets focus on the first menu item of the given menu.
* @param {jQuery} menu - The jQuery object representing the menu.
*/
function setFocusOnFirstMenuItem(menu) {
    menu.next().children().first().focus();
}

/**
* Closes all open dropdown menus
* @param {Object} menuSelector - The jQuery selector for the menu
* @returns {Object} - The jQuery selector for the menu
*/
function closeOpenDropdownMenus(menuSelector) {
    return menuSelector
        .removeClass("show")
        .children(".dropdown-menu")
        .removeClass("show");
}

/**
* Displays a dropdown menu by adding the "show" class to the menu and its children.
*
* @param {jQuery} menuSelector - The jQuery object representing the menu element to be shown.
*/
function showDropMenu(menuSelector) {
    menuSelector.addClass("show").children(".dropdown-menu").addClass("show");
}

/**
* Sets focus to the first link within a menu.
*
* @param {jQuery} menuSelector - A jQuery object representing the menu container.
*/
function focusFirstLink(menuSelector) {
    menuSelector.find("ul > li > a").first().focus();
}

/**
* Hides the header banner
*/
function hideHeaderBanner() {
    var headerBannerStatus = window.sessionStorage.getItem("hide_header_banner");
    var $headerBanner = $(".header-banner");
    $(".header-banner .close").on("click", function () {
        $headerBanner.addClass("d-none");
        window.sessionStorage.setItem("hide_header_banner", "1");
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $headerBanner.removeClass("d-none");
    }
}

/**
* Adds keyboard accessibility to the main menu
*/
function menuAccessibility() {
    keyboardAccessibility(".main-menu .nav-link, .main-menu .dropdown-link",
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass("nav-item")) { // top level
                    closeOpenDropdownMenus($(".navbar-nav .show"));
                    showDropMenu(menuItem);
                    focusFirstLink(menuItem);
                } else {
                    closeOpenDropdownMenus(menuItem);
                    if (menuItem.next().length === 0) { // if this is the last menuItem
                        menuItem.parent().parent().find("li > a") // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        setFocusOnFirstMenuItem(menuItem);
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass("nav-item")) { // top level
                    closeOpenDropdownMenus(menuItem);
                    $(this).attr("aria-expanded", "false");
                    setFocusOnFirstMenuItem(menuItem);
                } else if (menuItem.hasClass("dropdown")) {
                    showDropMenu(menuItem);
                    $(this).attr("aria-expanded", "true");
                    focusFirstLink(menuItem);
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass("nav-item")) { // top level
                    closeOpenDropdownMenus(menuItem);
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass("show")
                        .children(".nav-link")
                        .attr("aria-expanded", "false");
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass("nav-item")) { // top level
                    closeOpenDropdownMenus(menuItem);
                    $(this).attr("aria-expanded", "false");
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest(".show").removeClass("show")
                        .closest("li.show").removeClass("show")
                        .children()
                        .first()
                        .focus()
                        .attr("aria-expanded", "false");
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass("show")
                    ? menuItem
                    : menuItem.closest("li.show");
                parentMenu.children(".show").removeClass("show");
                parentMenu.removeClass("show").children(".nav-link")
                    .attr("aria-expanded", "false");
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );
}

/**
* Handles keyboard accessibility for user and minicart elements
*/
function keyboardAccessibilityFunctions() {
    keyboardAccessibility(".navbar-header .user",
        {
            40: function ($popover) { // down
                if ($popover.children("a").first().is(":focus")) {
                    setFocusOnFirstMenuItem($popover);
                } else {
                    $popover.children("a").first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children("a").first().is(":focus")) {
                    $(this).focus();
                    $popover.removeClass("show");
                } else {
                    $popover.children("a").first().focus();
                }
            },
            27: function () { // escape
                $(".navbar-header .user .popover").removeClass("show");
                $(".user").attr("aria-expanded", "false");
            }
        },
        function () {
            return $(".user .popover li.nav-item");
        }
    );
    keyboardAccessibility(".account-submit-btn",
        {
            9: function () { // tab
                $(this).next().focus();
                $(".user").attr("aria-expanded", "false");
            }
        },
        function () {
            return $(".minicart-total .popover li.nav-item");
        }
    );

    if ($window.width() > 768) {
        var $popover = $(".navbar-header .user .popover");
        var $navbarUser = $(".navbar-header .user");
        $navbarUser.on("mouseenter", function () {
            if ($popover.length > 0) {
                $popover.addClass("show");
                $(".user").attr("aria-expanded", "true");
            }
        });

        $navbarUser.on("mouseleave", function () {
            if (!$(".login-form-popin-email").is(":focus") && !$(".login-form-popin-password").is(":focus")) {
                $popover.removeClass("show");
                $(".user").attr("aria-expanded", "false");
            }
        });
    }
}

/**
* Checks whether the given element is in desktop mode
* @param {Element} element - the DOM element to check
* @returns {boolean} - true if the element is in desktop mode, false otherwise
*/
function isDesktop (element) {
    return $(element).parents(".menu-toggleable-left").css("position") !== "fixed";
}

/**
* Event handlers for dropdown menus
* @param {boolean} fromCore - flag indicating whether the menu is from the core or not
*/
function dropdownEventHandlers (fromCore) {
    $(".dropdown:not(.disabled) [data-toggle=\"dropdown\"]")
        .on("click", function (e) {
            if (!isDesktop(this)) {
                e.preventDefault();
                $(".modal-background").show();
                var $parentElement = $(this).parent();
                $parentElement.find(".dropdown-menu").slideToggle();
                $parentElement.toggleClass("show");
                $(this).attr("aria-expanded", "true");
                $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "true");
            }
        })
        .on("mouseenter", function () {
            if (isDesktop(this)) {
                var eventElement = this;
                $(".navbar-nav > li").each(function () {
                    if (!$.contains(this, eventElement)) {
                        var $this = $(this);
                        $this.find(".show").each(function () {
                            clearSelection(this, fromCore);
                        });
                        if ($this.hasClass("show")) {
                            $this.removeClass("show");
                            $this.children("ul.dropdown-menu").removeClass("show");
                            $this.children(".nav-link").attr("aria-expanded", "false");
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $(this).parent().addClass("show");
                $(this).siblings(".dropdown-menu").addClass("show");
                $(this).attr("aria-expanded", "true");
            }
        })
        .parent()
        .on("mouseleave", function () {
            if (isDesktop(this)) {
                var $this = $(this);
                closeOpenDropdownMenus($this);
                $this.children(".nav-link").attr("aria-expanded", "false");
            }
        });
}

/**
* Updates the selection of the dropdown menu
* @param {HTMLElement} element - the element to update
*/
function updateSelection(element) {
    var $dropdowsShow = $(element).closest(".dropdown.show");
    $dropdowsShow.children(".nav-link").attr("aria-expanded", "false");
    $dropdowsShow.children(".dropdown-menu").attr("aria-hidden", "true");
    $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "false");
}

/**
* Clears the selection from the menu
* @param {Element} element - the element to be cleared
* @param {boolean} fromCore - whether the element is from the core
*/
function clearSelection(element, fromCore) {
    var $dropdown = $(element).closest(".dropdown.show");
    if (fromCore) {
        updateSelection(element);
        $dropdown.removeClass("show");
        $(element).closest("li").detach();
    } else {
        $dropdown.children(".nav-link").attr("aria-expanded", "false");
        $dropdown.children(".dropdown-menu").attr("aria-hidden", "true");
        $dropdown.removeClass("show");
        $("div.menu-group > ul.nav.navbar-nav > li.nav-item > a").attr("aria-hidden", "false");
        $(element).closest("li").detach();
    }
}

/**
* Clears all selection when the dropdown is closed
*/
function clearAllSelectionOnClose() {
    $(".dropdown.show").each(function () {
        updateSelection(this);
        $(this).find(".dropdown-item.top-category").detach();
    });
}

/**
* Clears the navbar selection when the back button is clicked
* @param {boolean} fromCore - whether the back button is from the core
*/
function clearNavbarSelection(fromCore) {
    $(".navbar-nav").on("click", ".back", function (e) {
        e.preventDefault();
        clearSelection(this, fromCore);
    });
}

/**
* Closes the menu when the user clicks the close button
* @param {Object} e - the event object
*/
function closeMenu(e) {
    e.preventDefault();
    $(".navbar-nav").find(".show").removeClass("show");
    $("body").removeClass("menu-active");
    $(".navbar-nav").find(".dropdown-menu").hide();
    $(".menu-toggleable-left").removeClass("in");
    $(".modal-background").hide();
    $(".navbar-toggler").focus();
    $(".main-menu").attr("aria-hidden", "true");
    $(".main-menu").siblings().attr("aria-hidden", "false");
    $("header").siblings().attr("aria-hidden", "false");
}

/**
* Toggles the visibility of the main menu
* @param {Event} e - the event object
*/
function toggleNavbar(e) {
    e.preventDefault();
    var $mainMenu = $(".main-menu");
    $mainMenu.toggleClass("in");
    $(".modal-background").show();
    $("body").addClass("menu-active");
    $mainMenu.removeClass("d-none");
    $mainMenu.attr("aria-hidden", "false");
    $mainMenu.siblings().attr("aria-hidden", "true");
    $("header").siblings().attr("aria-hidden", "true");

    $(".main-menu .nav.navbar-nav .nav-link").first().focus();
}

/**
* Handles the click event on the navigation subscribe button
* @param {boolean} useCloseButton - whether to use the close button or not
*/
function handleNavSubscribeClick(useCloseButton) {
    $(".js-nav-subscribe").on("click", function () {
        var $target = $(".home-email-signup");
        if (useCloseButton) {
            $(".navbar>.close-menu>.close-button").trigger("click");
        } else {
            $(".js-close-menu").trigger("click");
        }
        $(".js-fields-toggler").trigger("click");
        $("html, body").animate({
            scrollTop: $target.offset().top
        }, {
            duration: 1000,
            step: function(now, fx) {
                var newOffset = $target.offset().top;
                if (fx.end !== newOffset) {
                    fx.end = newOffset;
                }
            }
        });
    });
}

module.exports = {
    menuAccessibility,
    isDesktop,
    hideHeaderBanner,
    keyboardAccessibilityFunctions,
    dropdownEventHandlers,
    clearSelection,
    clearAllSelectionOnClose,
    clearNavbarSelection,
    closeMenu,
    toggleNavbar,
    handleNavSubscribeClick
};
